export interface SearchStringObject {
    [key: string]: string;
}

/**
 * Returns a key-value pair of query params from given search string
 * @param search
 */
export const parseUrlSearchParams = (search: string): SearchStringObject => {
    // Split into key/value pairs
    const queryParamsString = search.indexOf('?') === 0 ? search.slice(1) : search;
    const queries = queryParamsString?.split('&') ?? [];
    return queries.reduce((result: SearchStringObject, current: string) => {
        const pair = current.split('=');
        if (pair.length > 1) {
            result[pair[0]] = decodeURIComponent(pair[1]);
        }
        return result;
    }, {});
};
